import { Link } from "react-router-dom";
import { useState } from "react";
import _axios from "../../httpService";
import { toast } from "react-toastify";
// import Swal from "sweetalert2/dist/sweetalert2.js";
// import "sweetalert2/src/sweetalert2.scss";
import Swal from "sweetalert2";

// import "./sidebarAssistant.css";
const ReportSidebar = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const deleteHandler = (e) => {
    let target = { id: e.target.id };
    console.log(target);
    Swal.fire({
      text: "آیا از حذف گزارش اطمینان دارید؟",
      padding: "1em",
      showCancelButton: true,
      cancelButtonText: "انصراف",
      confirmButtonText: "تایید",
      confirmButtonColor: "#4ca7a8",
    }).then((result) => {
      if (result.isConfirmed) {
        _axios.post("z/dr/", target).then((response) => {
          toast.success(response.data.message);
        });
      }
    });
    // Swal.fire({
    //   title: "Error!",
    //   text: "Do you want to continue",
    //   icon: "error",
    //   confirmButtonText: "Cool",
    // });
  };

  return (
    <>
      <li className="report-side-item" key={props.data.id} id={props.data.id}>
        {props.data.name}
        <div
          className="open-side-option"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <i className="far fa-ellipsis-v show-option-menu"></i>
          {isMenuOpen && (
            <div className="open-menu-option">
              <div className="form-options">
                <div className="form-options-item">
                  <Link
                    to={`/assistant/addNewReport/${props.data.id}`}
                    state={{ mode: "edit" }}
                  >
                    ویرایش گزارش
                  </Link>
                  <i className="far fa-edit"></i>
                </div>
                <div className="form-options-item">
                  باز کردن گزارش
                  <i className="far fa-play"></i>
                </div>

                <div
                  className="form-options-item"
                  id={props.data.id}
                  onClick={deleteHandler}
                >
                  حذف گزارش
                  <i className="far fa-trash"></i>
                </div>
              </div>
            </div>
          )}
        </div>
      </li>
    </>
  );
};
export default ReportSidebar;
